import { render, staticRenderFns } from "./insureUser.vue?vue&type=template&id=6f1d5d21&scoped=true"
import script from "./insureUser.vue?vue&type=script&lang=js"
export * from "./insureUser.vue?vue&type=script&lang=js"
import style0 from "./insureUser.vue?vue&type=style&index=0&id=6f1d5d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1d5d21",
  null
  
)

export default component.exports